/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForbiddenRouteImport } from './routes/forbidden'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthIsUserRouteImport } from './routes/_auth/_isUser'
import { Route as AuthIsAdminRouteImport } from './routes/_auth/_isAdmin'
import { Route as AuthUnternehmenIndexRouteImport } from './routes/_auth/unternehmen/index'
import { Route as AuthRahmenvertragIndexRouteImport } from './routes/_auth/rahmenvertrag/index'
import { Route as AuthEinzelvertragIndexRouteImport } from './routes/_auth/einzelvertrag/index'
import { Route as AuthEditorIndexRouteImport } from './routes/_auth/editor/index'
import { Route as AuthBeraterIndexRouteImport } from './routes/_auth/berater/index'
import { Route as AuthUnternehmenCompanyIdRouteImport } from './routes/_auth/unternehmen/$companyId'
import { Route as AuthRahmenvertragFrameworkContractIdRouteImport } from './routes/_auth/rahmenvertrag/$frameworkContractId'
import { Route as AuthEinzelvertragIndividualContractIdRouteImport } from './routes/_auth/einzelvertrag/$individualContractId'
import { Route as AuthBeraterConsultantIdRouteImport } from './routes/_auth/berater/$consultantId'
import { Route as AuthAuditLogsAuditLogIdRouteImport } from './routes/_auth/audit-logs/$auditLogId'
import { Route as AuthUnternehmenAnlegenIndexRouteImport } from './routes/_auth/unternehmen/anlegen/index'
import { Route as AuthRahmenvertragAnlegenIndexRouteImport } from './routes/_auth/rahmenvertrag/anlegen/index'
import { Route as AuthEinzelvertragAnlegenIndexRouteImport } from './routes/_auth/einzelvertrag/anlegen/index'
import { Route as AuthDemoLookupIndexRouteImport } from './routes/_auth/demo/lookup/index'
import { Route as AuthIsUserDashboardIndexRouteImport } from './routes/_auth/_isUser/dashboard/index'
import { Route as AuthIsAdminEinstellungenEntraIndexRouteImport } from './routes/_auth/_isAdmin/einstellungen/entra/index'
import { Route as AuthIsAdminEinstellungenDocusignIndexRouteImport } from './routes/_auth/_isAdmin/einstellungen/docusign/index'
import { Route as AuthIsAdminEinstellungenBenutzerIndexRouteImport } from './routes/_auth/_isAdmin/einstellungen/benutzer/index'

const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForbiddenRoute = ForbiddenRouteImport.update({
  id: '/forbidden',
  path: '/forbidden',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIsUserRoute = AuthIsUserRouteImport.update({
  id: '/_isUser',
  getParentRoute: () => AuthRoute,
} as any)
const AuthIsAdminRoute = AuthIsAdminRouteImport.update({
  id: '/_isAdmin',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUnternehmenIndexRoute = AuthUnternehmenIndexRouteImport.update({
  id: '/unternehmen/',
  path: '/unternehmen/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRahmenvertragIndexRoute = AuthRahmenvertragIndexRouteImport.update({
  id: '/rahmenvertrag/',
  path: '/rahmenvertrag/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthEinzelvertragIndexRoute = AuthEinzelvertragIndexRouteImport.update({
  id: '/einzelvertrag/',
  path: '/einzelvertrag/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthEditorIndexRoute = AuthEditorIndexRouteImport.update({
  id: '/editor/',
  path: '/editor/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBeraterIndexRoute = AuthBeraterIndexRouteImport.update({
  id: '/berater/',
  path: '/berater/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUnternehmenCompanyIdRoute =
  AuthUnternehmenCompanyIdRouteImport.update({
    id: '/unternehmen/$companyId',
    path: '/unternehmen/$companyId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthRahmenvertragFrameworkContractIdRoute =
  AuthRahmenvertragFrameworkContractIdRouteImport.update({
    id: '/rahmenvertrag/$frameworkContractId',
    path: '/rahmenvertrag/$frameworkContractId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthEinzelvertragIndividualContractIdRoute =
  AuthEinzelvertragIndividualContractIdRouteImport.update({
    id: '/einzelvertrag/$individualContractId',
    path: '/einzelvertrag/$individualContractId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthBeraterConsultantIdRoute = AuthBeraterConsultantIdRouteImport.update({
  id: '/berater/$consultantId',
  path: '/berater/$consultantId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAuditLogsAuditLogIdRoute = AuthAuditLogsAuditLogIdRouteImport.update({
  id: '/audit-logs/$auditLogId',
  path: '/audit-logs/$auditLogId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUnternehmenAnlegenIndexRoute =
  AuthUnternehmenAnlegenIndexRouteImport.update({
    id: '/unternehmen/anlegen/',
    path: '/unternehmen/anlegen/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthRahmenvertragAnlegenIndexRoute =
  AuthRahmenvertragAnlegenIndexRouteImport.update({
    id: '/rahmenvertrag/anlegen/',
    path: '/rahmenvertrag/anlegen/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthEinzelvertragAnlegenIndexRoute =
  AuthEinzelvertragAnlegenIndexRouteImport.update({
    id: '/einzelvertrag/anlegen/',
    path: '/einzelvertrag/anlegen/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthDemoLookupIndexRoute = AuthDemoLookupIndexRouteImport.update({
  id: '/demo/lookup/',
  path: '/demo/lookup/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthIsUserDashboardIndexRoute =
  AuthIsUserDashboardIndexRouteImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => AuthIsUserRoute,
  } as any)
const AuthIsAdminEinstellungenEntraIndexRoute =
  AuthIsAdminEinstellungenEntraIndexRouteImport.update({
    id: '/einstellungen/entra/',
    path: '/einstellungen/entra/',
    getParentRoute: () => AuthIsAdminRoute,
  } as any)
const AuthIsAdminEinstellungenDocusignIndexRoute =
  AuthIsAdminEinstellungenDocusignIndexRouteImport.update({
    id: '/einstellungen/docusign/',
    path: '/einstellungen/docusign/',
    getParentRoute: () => AuthIsAdminRoute,
  } as any)
const AuthIsAdminEinstellungenBenutzerIndexRoute =
  AuthIsAdminEinstellungenBenutzerIndexRouteImport.update({
    id: '/einstellungen/benutzer/',
    path: '/einstellungen/benutzer/',
    getParentRoute: () => AuthIsAdminRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forbidden': typeof ForbiddenRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/audit-logs/$auditLogId': typeof AuthAuditLogsAuditLogIdRoute
  '/berater/$consultantId': typeof AuthBeraterConsultantIdRoute
  '/einzelvertrag/$individualContractId': typeof AuthEinzelvertragIndividualContractIdRoute
  '/rahmenvertrag/$frameworkContractId': typeof AuthRahmenvertragFrameworkContractIdRoute
  '/unternehmen/$companyId': typeof AuthUnternehmenCompanyIdRoute
  '/berater/': typeof AuthBeraterIndexRoute
  '/editor/': typeof AuthEditorIndexRoute
  '/einzelvertrag/': typeof AuthEinzelvertragIndexRoute
  '/rahmenvertrag/': typeof AuthRahmenvertragIndexRoute
  '/unternehmen/': typeof AuthUnternehmenIndexRoute
  '/dashboard/': typeof AuthIsUserDashboardIndexRoute
  '/demo/lookup/': typeof AuthDemoLookupIndexRoute
  '/einzelvertrag/anlegen/': typeof AuthEinzelvertragAnlegenIndexRoute
  '/rahmenvertrag/anlegen/': typeof AuthRahmenvertragAnlegenIndexRoute
  '/unternehmen/anlegen/': typeof AuthUnternehmenAnlegenIndexRoute
  '/einstellungen/benutzer/': typeof AuthIsAdminEinstellungenBenutzerIndexRoute
  '/einstellungen/docusign/': typeof AuthIsAdminEinstellungenDocusignIndexRoute
  '/einstellungen/entra/': typeof AuthIsAdminEinstellungenEntraIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forbidden': typeof ForbiddenRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/audit-logs/$auditLogId': typeof AuthAuditLogsAuditLogIdRoute
  '/berater/$consultantId': typeof AuthBeraterConsultantIdRoute
  '/einzelvertrag/$individualContractId': typeof AuthEinzelvertragIndividualContractIdRoute
  '/rahmenvertrag/$frameworkContractId': typeof AuthRahmenvertragFrameworkContractIdRoute
  '/unternehmen/$companyId': typeof AuthUnternehmenCompanyIdRoute
  '/berater': typeof AuthBeraterIndexRoute
  '/editor': typeof AuthEditorIndexRoute
  '/einzelvertrag': typeof AuthEinzelvertragIndexRoute
  '/rahmenvertrag': typeof AuthRahmenvertragIndexRoute
  '/unternehmen': typeof AuthUnternehmenIndexRoute
  '/dashboard': typeof AuthIsUserDashboardIndexRoute
  '/demo/lookup': typeof AuthDemoLookupIndexRoute
  '/einzelvertrag/anlegen': typeof AuthEinzelvertragAnlegenIndexRoute
  '/rahmenvertrag/anlegen': typeof AuthRahmenvertragAnlegenIndexRoute
  '/unternehmen/anlegen': typeof AuthUnternehmenAnlegenIndexRoute
  '/einstellungen/benutzer': typeof AuthIsAdminEinstellungenBenutzerIndexRoute
  '/einstellungen/docusign': typeof AuthIsAdminEinstellungenDocusignIndexRoute
  '/einstellungen/entra': typeof AuthIsAdminEinstellungenEntraIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/forbidden': typeof ForbiddenRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/_auth/_isAdmin': typeof AuthIsAdminRouteWithChildren
  '/_auth/_isUser': typeof AuthIsUserRouteWithChildren
  '/_auth/audit-logs/$auditLogId': typeof AuthAuditLogsAuditLogIdRoute
  '/_auth/berater/$consultantId': typeof AuthBeraterConsultantIdRoute
  '/_auth/einzelvertrag/$individualContractId': typeof AuthEinzelvertragIndividualContractIdRoute
  '/_auth/rahmenvertrag/$frameworkContractId': typeof AuthRahmenvertragFrameworkContractIdRoute
  '/_auth/unternehmen/$companyId': typeof AuthUnternehmenCompanyIdRoute
  '/_auth/berater/': typeof AuthBeraterIndexRoute
  '/_auth/editor/': typeof AuthEditorIndexRoute
  '/_auth/einzelvertrag/': typeof AuthEinzelvertragIndexRoute
  '/_auth/rahmenvertrag/': typeof AuthRahmenvertragIndexRoute
  '/_auth/unternehmen/': typeof AuthUnternehmenIndexRoute
  '/_auth/_isUser/dashboard/': typeof AuthIsUserDashboardIndexRoute
  '/_auth/demo/lookup/': typeof AuthDemoLookupIndexRoute
  '/_auth/einzelvertrag/anlegen/': typeof AuthEinzelvertragAnlegenIndexRoute
  '/_auth/rahmenvertrag/anlegen/': typeof AuthRahmenvertragAnlegenIndexRoute
  '/_auth/unternehmen/anlegen/': typeof AuthUnternehmenAnlegenIndexRoute
  '/_auth/_isAdmin/einstellungen/benutzer/': typeof AuthIsAdminEinstellungenBenutzerIndexRoute
  '/_auth/_isAdmin/einstellungen/docusign/': typeof AuthIsAdminEinstellungenDocusignIndexRoute
  '/_auth/_isAdmin/einstellungen/entra/': typeof AuthIsAdminEinstellungenEntraIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forbidden'
    | '/login'
    | '/logout'
    | '/audit-logs/$auditLogId'
    | '/berater/$consultantId'
    | '/einzelvertrag/$individualContractId'
    | '/rahmenvertrag/$frameworkContractId'
    | '/unternehmen/$companyId'
    | '/berater/'
    | '/editor/'
    | '/einzelvertrag/'
    | '/rahmenvertrag/'
    | '/unternehmen/'
    | '/dashboard/'
    | '/demo/lookup/'
    | '/einzelvertrag/anlegen/'
    | '/rahmenvertrag/anlegen/'
    | '/unternehmen/anlegen/'
    | '/einstellungen/benutzer/'
    | '/einstellungen/docusign/'
    | '/einstellungen/entra/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forbidden'
    | '/login'
    | '/logout'
    | '/audit-logs/$auditLogId'
    | '/berater/$consultantId'
    | '/einzelvertrag/$individualContractId'
    | '/rahmenvertrag/$frameworkContractId'
    | '/unternehmen/$companyId'
    | '/berater'
    | '/editor'
    | '/einzelvertrag'
    | '/rahmenvertrag'
    | '/unternehmen'
    | '/dashboard'
    | '/demo/lookup'
    | '/einzelvertrag/anlegen'
    | '/rahmenvertrag/anlegen'
    | '/unternehmen/anlegen'
    | '/einstellungen/benutzer'
    | '/einstellungen/docusign'
    | '/einstellungen/entra'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/forbidden'
    | '/login'
    | '/logout'
    | '/_auth/_isAdmin'
    | '/_auth/_isUser'
    | '/_auth/audit-logs/$auditLogId'
    | '/_auth/berater/$consultantId'
    | '/_auth/einzelvertrag/$individualContractId'
    | '/_auth/rahmenvertrag/$frameworkContractId'
    | '/_auth/unternehmen/$companyId'
    | '/_auth/berater/'
    | '/_auth/editor/'
    | '/_auth/einzelvertrag/'
    | '/_auth/rahmenvertrag/'
    | '/_auth/unternehmen/'
    | '/_auth/_isUser/dashboard/'
    | '/_auth/demo/lookup/'
    | '/_auth/einzelvertrag/anlegen/'
    | '/_auth/rahmenvertrag/anlegen/'
    | '/_auth/unternehmen/anlegen/'
    | '/_auth/_isAdmin/einstellungen/benutzer/'
    | '/_auth/_isAdmin/einstellungen/docusign/'
    | '/_auth/_isAdmin/einstellungen/entra/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  ForbiddenRoute: typeof ForbiddenRoute
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forbidden': {
      id: '/forbidden'
      path: '/forbidden'
      fullPath: '/forbidden'
      preLoaderRoute: typeof ForbiddenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/_isUser': {
      id: '/_auth/_isUser'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthIsUserRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_isAdmin': {
      id: '/_auth/_isAdmin'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthIsAdminRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/unternehmen/': {
      id: '/_auth/unternehmen/'
      path: '/unternehmen'
      fullPath: '/unternehmen/'
      preLoaderRoute: typeof AuthUnternehmenIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/rahmenvertrag/': {
      id: '/_auth/rahmenvertrag/'
      path: '/rahmenvertrag'
      fullPath: '/rahmenvertrag/'
      preLoaderRoute: typeof AuthRahmenvertragIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/einzelvertrag/': {
      id: '/_auth/einzelvertrag/'
      path: '/einzelvertrag'
      fullPath: '/einzelvertrag/'
      preLoaderRoute: typeof AuthEinzelvertragIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/editor/': {
      id: '/_auth/editor/'
      path: '/editor'
      fullPath: '/editor/'
      preLoaderRoute: typeof AuthEditorIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/berater/': {
      id: '/_auth/berater/'
      path: '/berater'
      fullPath: '/berater/'
      preLoaderRoute: typeof AuthBeraterIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/unternehmen/$companyId': {
      id: '/_auth/unternehmen/$companyId'
      path: '/unternehmen/$companyId'
      fullPath: '/unternehmen/$companyId'
      preLoaderRoute: typeof AuthUnternehmenCompanyIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/rahmenvertrag/$frameworkContractId': {
      id: '/_auth/rahmenvertrag/$frameworkContractId'
      path: '/rahmenvertrag/$frameworkContractId'
      fullPath: '/rahmenvertrag/$frameworkContractId'
      preLoaderRoute: typeof AuthRahmenvertragFrameworkContractIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/einzelvertrag/$individualContractId': {
      id: '/_auth/einzelvertrag/$individualContractId'
      path: '/einzelvertrag/$individualContractId'
      fullPath: '/einzelvertrag/$individualContractId'
      preLoaderRoute: typeof AuthEinzelvertragIndividualContractIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/berater/$consultantId': {
      id: '/_auth/berater/$consultantId'
      path: '/berater/$consultantId'
      fullPath: '/berater/$consultantId'
      preLoaderRoute: typeof AuthBeraterConsultantIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/audit-logs/$auditLogId': {
      id: '/_auth/audit-logs/$auditLogId'
      path: '/audit-logs/$auditLogId'
      fullPath: '/audit-logs/$auditLogId'
      preLoaderRoute: typeof AuthAuditLogsAuditLogIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/unternehmen/anlegen/': {
      id: '/_auth/unternehmen/anlegen/'
      path: '/unternehmen/anlegen'
      fullPath: '/unternehmen/anlegen/'
      preLoaderRoute: typeof AuthUnternehmenAnlegenIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/rahmenvertrag/anlegen/': {
      id: '/_auth/rahmenvertrag/anlegen/'
      path: '/rahmenvertrag/anlegen'
      fullPath: '/rahmenvertrag/anlegen/'
      preLoaderRoute: typeof AuthRahmenvertragAnlegenIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/einzelvertrag/anlegen/': {
      id: '/_auth/einzelvertrag/anlegen/'
      path: '/einzelvertrag/anlegen'
      fullPath: '/einzelvertrag/anlegen/'
      preLoaderRoute: typeof AuthEinzelvertragAnlegenIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/demo/lookup/': {
      id: '/_auth/demo/lookup/'
      path: '/demo/lookup'
      fullPath: '/demo/lookup/'
      preLoaderRoute: typeof AuthDemoLookupIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_isUser/dashboard/': {
      id: '/_auth/_isUser/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AuthIsUserDashboardIndexRouteImport
      parentRoute: typeof AuthIsUserRoute
    }
    '/_auth/_isAdmin/einstellungen/entra/': {
      id: '/_auth/_isAdmin/einstellungen/entra/'
      path: '/einstellungen/entra'
      fullPath: '/einstellungen/entra/'
      preLoaderRoute: typeof AuthIsAdminEinstellungenEntraIndexRouteImport
      parentRoute: typeof AuthIsAdminRoute
    }
    '/_auth/_isAdmin/einstellungen/docusign/': {
      id: '/_auth/_isAdmin/einstellungen/docusign/'
      path: '/einstellungen/docusign'
      fullPath: '/einstellungen/docusign/'
      preLoaderRoute: typeof AuthIsAdminEinstellungenDocusignIndexRouteImport
      parentRoute: typeof AuthIsAdminRoute
    }
    '/_auth/_isAdmin/einstellungen/benutzer/': {
      id: '/_auth/_isAdmin/einstellungen/benutzer/'
      path: '/einstellungen/benutzer'
      fullPath: '/einstellungen/benutzer/'
      preLoaderRoute: typeof AuthIsAdminEinstellungenBenutzerIndexRouteImport
      parentRoute: typeof AuthIsAdminRoute
    }
  }
}

interface AuthIsAdminRouteChildren {
  AuthIsAdminEinstellungenBenutzerIndexRoute: typeof AuthIsAdminEinstellungenBenutzerIndexRoute
  AuthIsAdminEinstellungenDocusignIndexRoute: typeof AuthIsAdminEinstellungenDocusignIndexRoute
  AuthIsAdminEinstellungenEntraIndexRoute: typeof AuthIsAdminEinstellungenEntraIndexRoute
}

const AuthIsAdminRouteChildren: AuthIsAdminRouteChildren = {
  AuthIsAdminEinstellungenBenutzerIndexRoute:
    AuthIsAdminEinstellungenBenutzerIndexRoute,
  AuthIsAdminEinstellungenDocusignIndexRoute:
    AuthIsAdminEinstellungenDocusignIndexRoute,
  AuthIsAdminEinstellungenEntraIndexRoute:
    AuthIsAdminEinstellungenEntraIndexRoute,
}

const AuthIsAdminRouteWithChildren = AuthIsAdminRoute._addFileChildren(
  AuthIsAdminRouteChildren,
)

interface AuthIsUserRouteChildren {
  AuthIsUserDashboardIndexRoute: typeof AuthIsUserDashboardIndexRoute
}

const AuthIsUserRouteChildren: AuthIsUserRouteChildren = {
  AuthIsUserDashboardIndexRoute: AuthIsUserDashboardIndexRoute,
}

const AuthIsUserRouteWithChildren = AuthIsUserRoute._addFileChildren(
  AuthIsUserRouteChildren,
)

interface AuthRouteChildren {
  AuthIsAdminRoute: typeof AuthIsAdminRouteWithChildren
  AuthIsUserRoute: typeof AuthIsUserRouteWithChildren
  AuthAuditLogsAuditLogIdRoute: typeof AuthAuditLogsAuditLogIdRoute
  AuthBeraterConsultantIdRoute: typeof AuthBeraterConsultantIdRoute
  AuthEinzelvertragIndividualContractIdRoute: typeof AuthEinzelvertragIndividualContractIdRoute
  AuthRahmenvertragFrameworkContractIdRoute: typeof AuthRahmenvertragFrameworkContractIdRoute
  AuthUnternehmenCompanyIdRoute: typeof AuthUnternehmenCompanyIdRoute
  AuthBeraterIndexRoute: typeof AuthBeraterIndexRoute
  AuthEditorIndexRoute: typeof AuthEditorIndexRoute
  AuthEinzelvertragIndexRoute: typeof AuthEinzelvertragIndexRoute
  AuthRahmenvertragIndexRoute: typeof AuthRahmenvertragIndexRoute
  AuthUnternehmenIndexRoute: typeof AuthUnternehmenIndexRoute
  AuthDemoLookupIndexRoute: typeof AuthDemoLookupIndexRoute
  AuthEinzelvertragAnlegenIndexRoute: typeof AuthEinzelvertragAnlegenIndexRoute
  AuthRahmenvertragAnlegenIndexRoute: typeof AuthRahmenvertragAnlegenIndexRoute
  AuthUnternehmenAnlegenIndexRoute: typeof AuthUnternehmenAnlegenIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthIsAdminRoute: AuthIsAdminRouteWithChildren,
  AuthIsUserRoute: AuthIsUserRouteWithChildren,
  AuthAuditLogsAuditLogIdRoute: AuthAuditLogsAuditLogIdRoute,
  AuthBeraterConsultantIdRoute: AuthBeraterConsultantIdRoute,
  AuthEinzelvertragIndividualContractIdRoute:
    AuthEinzelvertragIndividualContractIdRoute,
  AuthRahmenvertragFrameworkContractIdRoute:
    AuthRahmenvertragFrameworkContractIdRoute,
  AuthUnternehmenCompanyIdRoute: AuthUnternehmenCompanyIdRoute,
  AuthBeraterIndexRoute: AuthBeraterIndexRoute,
  AuthEditorIndexRoute: AuthEditorIndexRoute,
  AuthEinzelvertragIndexRoute: AuthEinzelvertragIndexRoute,
  AuthRahmenvertragIndexRoute: AuthRahmenvertragIndexRoute,
  AuthUnternehmenIndexRoute: AuthUnternehmenIndexRoute,
  AuthDemoLookupIndexRoute: AuthDemoLookupIndexRoute,
  AuthEinzelvertragAnlegenIndexRoute: AuthEinzelvertragAnlegenIndexRoute,
  AuthRahmenvertragAnlegenIndexRoute: AuthRahmenvertragAnlegenIndexRoute,
  AuthUnternehmenAnlegenIndexRoute: AuthUnternehmenAnlegenIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  ForbiddenRoute: ForbiddenRoute,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
